import { ChecklistScope } from 'generated/graphql';

type ChecklistForStrategyFilter = {
  scope: ChecklistScope;
  strategyIds: string[];
};

const sortChecklistsAnyScopeFirst = <T extends ChecklistForStrategyFilter>(
  checklists: T[],
): T[] =>
  [...checklists].sort((a, b) => {
    const aIsAny = a.scope === ChecklistScope.Any;
    const bIsAny = b.scope === ChecklistScope.Any;
    if (aIsAny && !bIsAny) return -1;
    if (!aIsAny && bIsAny) return 1;
    return 0;
  });

export const filterChecklistsForStrategy = <
  T extends ChecklistForStrategyFilter,
>(
  checklists: T[],
  strategyId: string | null,
): T[] => {
  if (!strategyId) {
    return checklists.filter((c) => c.scope === ChecklistScope.None);
  }

  const filtered = checklists.filter((c) => {
    if (c.scope === ChecklistScope.Any) return true;
    if (c.scope === ChecklistScope.Strategy) {
      return c.strategyIds.includes(strategyId);
    }
    return false;
  });

  return sortChecklistsAnyScopeFirst(filtered);
};
